import React from 'react';

const fileUploadStatus = {
    ReadyToUpload: 0,
    Uploading: 1,
    Uploaded: 2
}

const serviceRequestStatus = {
    Uploading: 1,
    WaitingForInput: 2,
    ReadyToApply: 3,
    Applying: 4,
    Succeeded: 5,
    Failed: 6,
    Canceled: 7,
}

const serviceRequestRunStatus = {
    Pending: 1,
    Success: 2,
    Failed: 3,
    Canceled: 4
}

const annotationServices = [
    'boundary-annotation',
    'bounding-box-annotation',
    'classification-annotation',
]
const annotationType = Object.freeze({
    CLASSIFICATION: 1,
    BOUNDARY: 2,
    BOUNDING_BOX: 3
})

const serviceRunConfig = {
    settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: false,
                redirectOn401: false,
                footer: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/service-run',
            component: React.lazy(() => import('./service-run-page'))
        }
    ]
};

export default serviceRunConfig;
export { fileUploadStatus, serviceRequestStatus, serviceRequestRunStatus, annotationServices, annotationType }